/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/grabber'
export default icon
